function trackDrawerQuantity(change, itemElement) {
  try {
    if (!itemElement) return;

    let payloadInput = itemElement.querySelector('.gtmPayload');
    let gtmPayloadRaw = payloadInput ? payloadInput.value : null;
    console.log(gtmPayloadRaw, "hello");
    
    if (gtmPayloadRaw) {
      let fullData = JSON.parse(gtmPayloadRaw);
      let eventName = (change > 0) ? 'add_to_cart' : 'remove_from_cart';
      
      let itemPrice = parseFloat(fullData.ecommerce?.items[0]?.price || 0);
      const item = fullData.ecommerce?.items?.[0];
      let itemQuantity = 1; // Drawer change usually tracks 1 by 1
      let finalPrice = parseFloat(itemPrice * itemQuantity);

      let ga4Payload = {
        event: eventName,
        ecommerce: {
          currency: fullData.ecommerce?.currency,
          value: Number(finalPrice.toFixed(2)), 
          items: [{
            ...item,
            quantity: itemQuantity,
          }]
        }
      };

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push(ga4Payload);
      console.log(`Tracked ${eventName}:`, ga4Payload);
    } else {
      console.warn("Payload input nahi mila is itemElement mein:", itemElement);
    }
  } catch (err) {
    console.error("GA4 Tracking Error:", err);
  }
}
function listenerForAtcAndWichlist(){
  
  let timeInterval = setInterval(() => {
    
    let wislistArray = document.querySelectorAll('.swym-button.swym-add-to-wishlist-view-product svg, .swym-button.swym-add-to-wishlist');
    
    let quicAddToCartArray = document.querySelectorAll('.addCartCstm:not(.active-event)');
    
    if(wislistArray.length > 0){
      clearInterval(timeInterval);
      wislistArray.forEach(item => {
        if (!item.classList.contains('active-event')) {
          item.classList.add('active-event');
          if (item.closest('.product__info-wrapper'))
          {
            item.addEventListener('click', function(e) {
              let gtmPayload = this.closest('.product__info-wrapper').querySelector('.gtmPayload').value;
              
              gtmPayload = JSON.parse(gtmPayload)
              window.dataLayer.push({ ecommerce: null });
              window.dataLayer.push(gtmPayload);
            })
          } else {
          item.addEventListener('click', function(e) {
            
            let gtmPayload = this.closest('.product-card-wrapper').querySelector('.gtmPayload').value;
            gtmPayload = JSON.parse(gtmPayload)
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push(gtmPayload);
          })
            
          }
          
        }
      })
    }

  
    if(quicAddToCartArray.length > 0){
      clearInterval(timeInterval);
      quicAddToCartArray.forEach(item => {
        if (!item.classList.contains('active-event')) {
          item.classList.add('active-event');
          item.addEventListener('click', function(e) {
            
            let gtmPayload = this.closest('.product-card-wrapper').querySelector('.gtmPayload').value;
            gtmPayload = JSON.parse(gtmPayload)
            if(gtmPayload){
              gtmPayload.event = 'add_to_cart';
              window.dataLayer.push({ ecommerce: null });
              window.dataLayer.push(gtmPayload);
            }
          })
        }
      })
    }
  }, 300)
  
}
window.listenerForAtcAndWichlist = listenerForAtcAndWichlist

document.addEventListener("DOMContentLoaded", (event) => {
  listenerForAtcAndWichlist()

  let productPageATC = document.querySelector('[data-type="add-to-cart-form"]');
  if (productPageATC){
    productPageATC.addEventListener('submit', function(e) {
      let gtmPayload = document.querySelector('.gtmPayload[gtm-add-to-cart-attr]')?.value;
      gtmPayload = JSON.parse(gtmPayload)
      if(gtmPayload){
        gtmPayload.event = 'add_to_cart';
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push(gtmPayload);
      }
    })
  }

  // let mainCartRemoveButtonArray = document.querySelectorAll('#main-cart-items .deleteIconCart a');
  // mainCartRemoveButtonArray.forEach(item => {
  //   item.addEventListener('click', function(e) {
  //     let gtmPayload = this.closest('tr')?.querySelector('.gtmPayload')?.value;
  //     console.log('remove', gtmPayload)
  //     if(gtmPayload){
  //       gtmPayload = JSON.parse(gtmPayload)
  //       console.log('remove', gtmPayload)
  //       gtmPayload.event = 'remove_from_cart';
  //       window.dataLayer.push({ ecommerce: null });
  //       window.dataLayer.push(gtmPayload);
  //     }
  //   })
  // })

  function gtmClickCard() {
    let productCardList = document.querySelectorAll('.product-card-wrapper');
    productCardList.forEach(item => {
      if (!item.classList.contains('active-event')) {
        item.classList.add('active-event');
        item.querySelectorAll('a.product-link-main, a.full-unstyled-link').forEach(aEL => {
          aEL.addEventListener('click', (e) => {
            e.preventDefault();
            let redirectURL = aEL.href
            try {
              let rawPayload = JSON.parse(aEL.closest('.product-card-wrapper').querySelector('.gtmPayload').value)
              let redirectURL = aEL.href

              // --- FIX START: Save list info for the next page ---
            let listName = rawPayload.ecommerce.items[0].item_list_name;
            let listId = rawPayload.ecommerce.items[0].item_list_id;
            sessionStorage.setItem('ga4_last_list_name', listName);
            sessionStorage.setItem('ga4_last_list_id', listId);
            // --- FIX END ---

              let deblicatePayload = Object.assign({}, rawPayload);
              deblicatePayload.event = "select_item",
                
              delete deblicatePayload.ecommerce.currency
              delete deblicatePayload.ecommerce.value
  
              deblicatePayload.ecommerce['item_list_id'] = listId;
              deblicatePayload.ecommerce['item_list_name'] = listName;
  
              window.dataLayer.push({ ecommerce: null });
              window.dataLayer.push(deblicatePayload);
              
              setTimeout(() => { window.location.href = redirectURL; }, 100);
            } catch (error) {
              window.location.href = redirectURL;
            }
            
          });
        });
      }
    });
  }

  gtmClickCard();
  window.gtmClickCard = gtmClickCard;
});

function gtm_removeFromMainCart(e){
  let gtmPayload = e.closest('tr')?.querySelector('.gtmPayload')?.value;
  console.log(gtmPageLoad,"jjj")
  
  if(gtmPayload){
    gtmPayload = JSON.parse(gtmPayload)
    gtmPayload.event = 'remove_from_cart';
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(gtmPayload);
  }
}

window.gtm_removeFromMainCart = gtm_removeFromMainCart;

function gtm_removeFromCart(e) {
  
  let gtmPayload = e.closest('li')?.querySelector('.gtmPayload')?.value
  if (gtmPayload){
    gtmPayload = JSON.parse(gtmPayload)
    gtmPayload.event = 'remove_from_cart';
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(gtmPayload);
  }
}

window.gtm_removeFromCart = gtm_removeFromCart;